import { secondaryFontFamily, styled } from '@openeducation/oe-it-themes';
import { useTheme } from 'react-native-paper';
import Svg, { Path } from 'react-native-svg';

import { OEText } from '../../atoms';
import { letterSpacing, textTransform } from '../../style-utils';

export function CardRecommendedMark({ children }: { children: string }) {
  const theme = useTheme();
  return (
    <LabelContainer>
      <LabelTipWrapper>
        <Svg width="21" height="19" viewBox="0 0 18 20">
          <Path
            d="M20.7412 0.5V20.5H0.741211C11.7869 20.5 20.7412 11.5457 20.7412 0.5Z"
            fill={theme.colors.primary}
          />
        </Svg>
      </LabelTipWrapper>
      <OEText
        textAlign="center"
        fontSize={10}
        color={theme.colors.white}
        fontFamily={secondaryFontFamily}
        style={[textTransform('uppercase'), letterSpacing(2)]}
      >
        {children}
      </OEText>
    </LabelContainer>
  );
}

const LabelContainer = styled.View`
  position: absolute;
  top: -21px;
  right: -1px;
  height: 20px;
  padding-vertical: 4px;
  padding-horizontal: 8px;
  background-color: ${({ theme }) => theme.color.primary};
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  display: flex;
  justify-content: center;
  shadow-color: ${({ theme }) => theme.color.border};
  shadow-radius: 8px;
`;

const LabelTipWrapper = styled.View`
  position: absolute;
  top: 1px;
  left: -21px;
`;
